module.exports = __webpack_public_path__ + "media/public/images/slider/banner_mobile-b00a24b222212030221755dc6b4192ad.png";